import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import { volumeOptions } from '../constants';
import style from './buttons.module.less';

export const ShippingVolumeQuestion = ({ onSelect, selectedValue }) => (
  <div className={style['volume-button-container']}>
    {volumeOptions.map(({ upperLimit, message }) => (
      <Button
        key={upperLimit}
        className={classnames(style['volume-button'], {
          [style.selected]: selectedValue === upperLimit,
        })}
        onClick={() => onSelect(upperLimit)}
        theme='unstyled'
      >
        <Text textType={TextType.H3} value={message} />
      </Button>
    ))}
  </div>
);

ShippingVolumeQuestion.propTypes = {
  onSelect: PropTypes.func.isRequired,
  selectedValue: PropTypes.number.isRequired,
};
